import * as Sentry from '@sentry/react';
import { deserializeView, ViewModel } from '../../../models/view.model';
import { SocketViewSaved } from '../../../schemas/agent-conversation.schema';

/**
 * The view a `view_saved` frame carries, or null when the row is not one. The frame is the
 * agent's word for the api's row, so a row that is not one is reported and dropped rather than
 * thrown inside the socket subscriber.
 */
export function viewFromSavedFrame(frame: SocketViewSaved): ViewModel | null {
  if (typeof frame.view?.id !== 'number') {
    Sentry.logger.warn('view_saved frame without a view row', {
      conversationId: frame.conversation_id ?? null,
    });
    return null;
  }
  try {
    return deserializeView(frame.view);
  } catch (error) {
    Sentry.captureException(error, { tags: { feature: 'fd-assistant' } });
    return null;
  }
}
